import React, { Component } from 'react';
import { Container } from 'reactstrap';
import Layout from '../components/Layout';
import ArticleForm from '../modules/ArticleForm';

class NewArticlePage extends Component {
  getConfig = () => {
    const { state } = this.props.location;
    if (!state) {
      return undefined;
    } else {
      return state;
    }
  };

  getInitialValues = () => {
    const initialValues = { showOnHomepage: true, headerImageLarge: {} };
    const { state } = this.props.location;
    if (!state) {
      return initialValues;
    } else {
      return { ...initialValues, lang: state.lang };
    }
  };

  render() {
    return (
      <Layout>
        <Container>
          <h1>Nový článek</h1>
          <ArticleForm
            config={this.getConfig()}
            initialValues={this.getInitialValues()}
          />
        </Container>
      </Layout>
    );
  }
}

export default NewArticlePage;



// WEBPACK FOOTER //
// ./src/pages/NewArticlePage.js